<template>
  <v-app id="app">
    <div class="container" id="app-container">
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </v-app>
</template>
<script>
import Vue from "vue";
import Vuetify from "vuetify";
import VueAnalytics from 'vue-analytics'

Vue.use(Vuetify);

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0);

export default {
  name: "App"
};
</script>
<style lang="scss">
$font_path: "/assets/fonts/";
#app {
  @import url("https://fonts.googleapis.com/css?family=Muli:300,400,600,700,800,900&display=swap");
  @import url("https://fonts.googleapis.com/css?family=Yanone+Kaffeesatz:300,400,700&display=swap");
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: none;
  font-family: Muli;
  text-align: center;
  color: #2c3e50;
}
#app-container {
  // margin-left: 49px !important;
  max-height: 100vh;
  overflow-x: hidden;
  width: 100% !important;
  max-width: none;
  overflow-y: auto;
  position: relative;
  padding: 0;
  margin: 0;
  max-width: none;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
#welcome-goodbye-container {
  .error--text {
    color: white !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/App.vue